import { render, staticRenderFns } from "./daRenCell.vue?vue&type=template&id=2624cd22&scoped=true"
import script from "./daRenCell.vue?vue&type=script&lang=js"
export * from "./daRenCell.vue?vue&type=script&lang=js"
import style0 from "./daRenCell.vue?vue&type=style&index=0&id=2624cd22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624cd22",
  null
  
)

export default component.exports